import React from 'react';
import { StyleSheet, css } from 'aphrodite-jss';
var styles = StyleSheet.create({
  overlay: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    background: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    overflow: 'hidden'
  }
});

var Overlay = function Overlay(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick;
  return React.createElement("div", {
    className: css(styles.overlay),
    onClick: onClick,
    "data-element": "overlay"
  }, children);
};

export default Overlay;